var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"notification"},[(_vm.canClose)?_c('button',{staticClass:"delete",on:{"click":_vm.close}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }